import { useMutation } from "react-query";

import { downloadColumnTemplate } from "api/data";

import { EntityKind } from "models/entityKind";

export function useDownloadTemplateMutation(
  entityKind: EntityKind,
  filterId: { id: string },
  facilityFilterId: { id: string },
  setError: (error: string) => void
) {
  return useMutation(
    async () => {
      const id = entityKind === EntityKind.Well ? filterId.id : facilityFilterId.id;
      return await downloadColumnTemplate(id, entityKind);
    },
    {
      onSuccess: () => {
        setError("");
      },
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      onError: async (err: any) => {
        try {
          const blob = err?.response?.data;

          if (!blob || !(blob instanceof Blob)) {
            setError("Unable to connect to backend services.");
            return;
          }

          const text = await blob.text();

          let errorMessage = text;
          try {
            const errorJson = JSON.parse(text);
            errorMessage = errorJson.error || text;
          } catch {
            // JSON parsing failed, use raw text
          }
          setError(
            errorMessage ===
              "No wells found for export. Please ensure that wells are loaded."
              ? "Unable to download the template file due to no wells in the filter. Please ensure filter includes wells to export."
              : "Unable to download template file."
          );
        } catch {
          setError("Unable to download template file. An error occurred.");
        }
      }
    }
  );
}
